import React from 'react';

const Adverbs2 = () => {
  return (
    <div className="gadject-container">
      <div className="gadject-head">Adverbs examples:</div>

      <p id="table-adverb-txt">Adverb of time</p>
      <div className="adverb">
        <div className="table-adverb">
          <p>today</p>
          <p>yesterday</p>
          <p>tonight</p>
          <p>tomorrow</p>
          <p>now</p>
          <p>then</p>
          <p>later</p>
          <p>soon</p>
        </div>
        <div className="table-adverb">
          <p>èní</p>
          <p>àná </p>
          <p>alẹ́ òní</p>
          <p>ọla</p>
          <p>nisin</p>
          <p>nígbà náà</p>
          <p>lẹ́yìn náà</p>
          <p>náà</p>
        </div>
      </div>

      <p id="table-adverb-txt">Adverb of manner</p>
      <div className="adverb">
        <div className="table-adverb">
          <p>very</p>
          <p>pretty</p>
          <p>fast</p>
          <p>hardly</p>
          <p>carefully</p>
          <p>slowly</p>
          <p>mostly</p>
          <p>quickly</p>
        </div>

        <div className="table-adverb">
          <p>pupọ</p>
          <p>rẹwà</p>
          <p>yára</p>
          <p>bẹ́ẹ̀ kò</p>
          <p>fara balẹ̀</p>
          <p>díẹ̀díẹ̀</p>
          <p>ọ̀pọ̀ jù lọ</p>
          <p>kíákíá</p>
        </div>
      </div>

      <p id="table-adverb-txt">Adverb of place</p>
      <div className="adverb">
        <div className="table-adverb">
          <p>here</p>
          <p>there</p>
          <p>nowhere</p>
          <p>home</p>
          <p>everywhere</p>
          <p>out</p>
          <p>anywhere</p>
          <p>behind</p>
        </div>

        <div className="table-adverb">
          <p>ibí</p>
          <p>ibẹ̀</p>
          <p>kòsíbì</p>
          <p>ilé </p>
          <p>nibi gbogbo</p>
          <p>jáde</p>
          <p>nibi gbogbo</p>
          <p>sẹhin </p>
        </div>
      </div>
    </div>
  );
};
export default Adverbs2;
